/** Finds any video facade containers and instantiates them. */
export default function init(): void {
	document
		.querySelectorAll<HTMLDivElement>(".rt-video-facade-play")
		.forEach((playButton) => {
			playButton.addEventListener("click", () => {
				videoFacade(playButton);
			});
		});
}

/**
 * Instantiate a video facade on the provided element.
 *
 * @param target The element to use as the facade's parent.
 */
function videoFacade(target: HTMLElement) {
	const { dataset, parentElement } = target;
	if (!parentElement || !dataset.video) {
		return;
	}
	const { clientHeight: height, clientWidth: width } =
		parentElement as HTMLDivElement;

	const { title } = dataset;
	const path = `https://www.youtube.com/embed/${dataset.video}?feature=oembed&autoplay=1`;

	const video = `<div class="rt-embed-responsive rt-embed-responsive-16by9"><iframe loading="lazy" title="${title ?? ""}" src="${path}" allow="autoplay; clipboard-write; encrypted-media;" allowfullscreen="" name="fitvid0" height="${String(height)}" width="${String(width)}"></iframe></div>`;
	parentElement.innerHTML = video;
}
